import axios from 'axios';

// Cache for storing streetview availability results
const streetviewAvailabilityCache = new Map();

export function CreateGoogleMapsStreetviewUrl(lat, long, type = 'streetview') {
    const GOOGLE_MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
    
    const streetviewMetadataUrl =
        "https://maps.googleapis.com/maps/api/streetview/metadata?size=640x480&location=" +
        lat +
        "," +
        long +
        "&fov=120&pitch=0&key=" +
        GOOGLE_MAPS_KEY;

    const streetviewUrl =
        "https://maps.googleapis.com/maps/api/streetview?size=640x480&location=" +
        lat +
        "," +
        long +
        "&fov=120&pitch=0&key=" +
        GOOGLE_MAPS_KEY;

    const staticMapSatelliteUrl = `https://maps.googleapis.com/maps/api/staticmap`
        + `?center=${lat},${long}`
        + `&zoom=16`
        + `&size=533x300`
        + `&maptype=satellite`
        + `&markers=color:0x115451|size:mid|${lat},${long}`
        + `&key=${GOOGLE_MAPS_KEY}`;

    const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap`
        + `?center=${lat},${long}`
        + `&zoom=16`
        + `&size=533x300`
        + `&markers=color:0x115451|size:mid|${lat},${long}`
        + `&key=${GOOGLE_MAPS_KEY}`;
    
    if (type === 'map') {
        return staticMapUrl;
    }

    // Create cache key from coordinates
    const cacheKey = `${lat},${long}`;
    
    // If we don't have a cached result, start a background check
    if (!streetviewAvailabilityCache.has(cacheKey)) {
        // Set a temporary false value to prevent multiple simultaneous checks
        streetviewAvailabilityCache.set(cacheKey, false);
        
        // Start background check
        axios.get(streetviewMetadataUrl)
            .then(response => {
                streetviewAvailabilityCache.set(cacheKey, response.data.status === 'OK');
            })
            .catch(() => {
                streetviewAvailabilityCache.set(cacheKey, false);
            });
    }

    // Return based on cached availability
    const hasStreetview = streetviewAvailabilityCache.get(cacheKey);
    return hasStreetview ? streetviewUrl : staticMapSatelliteUrl;
}
